const pageNameKey = "otaCreateBackupModal";

export const otaCreateBackupModalEn = {
  [pageNameKey]: {
    closeCreateBackupModalAriaLabel: "Close create backup modal",
    title: "Create Backup",
    targetPathLabel: "Path to back up (subfolders and files included)",
    targetPathPlaceholder: "/appldisk",
    sourceMachineLabel: "Source machine",
    usernameLabel: "User name",
    usernamePlaceholder: "Enter user name",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter password",
    privateKeyFileLabel: "Private Key file instead password",
    helperText:
      "This request goes to the operator for approval. The backup won't start until they confirm it on the machine.",
    cancelButtonText: "Cancel",
    askForApprovalButtonText: "Ask for approval",
    showPasswordTooltip: "Show password",
    hidePasswordTooltip: "Hide password",
    pleaseFixFields: "Please fix the following fields:",
    failedToCreateProcess: "Failed to create backup process",
    processAlreadyExists: "A backup process already exists",
  },
};

export const otaCreateBackupModalPtBr = {
  [pageNameKey]: {
    closeCreateBackupModalAriaLabel: "Fechar modal de criar backup",
    title: "Criar Backup",
    targetPathLabel: "Caminho para backup (subpastas e arquivos incluídos)",
    targetPathPlaceholder: "/appldisk",
    sourceMachineLabel: "Máquina de origem",
    usernameLabel: "Nome de usuário",
    usernamePlaceholder: "Digite o nome de usuário",
    passwordLabel: "Senha",
    passwordPlaceholder: "Digite a senha",
    privateKeyFileLabel: "Arquivo de chave privada em vez da senha",
    helperText:
      "Esta solicitação vai para o operador para aprovação. O backup não começará até que ele confirme na máquina.",
    cancelButtonText: "Cancelar",
    askForApprovalButtonText: "Solicitar aprovação",
    showPasswordTooltip: "Mostrar senha",
    hidePasswordTooltip: "Ocultar senha",
    pleaseFixFields: "Por favor, corrija os seguintes campos:",
    failedToCreateProcess: "Falha ao criar o processo de backup",
    processAlreadyExists: "Já existe um processo de backup",
  },
};

export const otaCreateBackupModalDe = {
  [pageNameKey]: {
    closeCreateBackupModalAriaLabel:
      "Modal zum Erstellen eines Backups schließen",
    title: "Backup erstellen",
    targetPathLabel:
      "Pfad für das Backup (Unterordner und Dateien eingeschlossen)",
    targetPathPlaceholder: "/appldisk",
    sourceMachineLabel: "Quellmaschine",
    usernameLabel: "Benutzername",
    usernamePlaceholder: "Benutzernamen eingeben",
    passwordLabel: "Passwort",
    passwordPlaceholder: "Passwort eingeben",
    privateKeyFileLabel: "Private Schlüsseldatei statt Passwort",
    helperText:
      "Diese Anfrage geht zur Freigabe an den Operator. Das Backup startet erst, nachdem es auf der Maschine bestätigt wurde.",
    cancelButtonText: "Abbrechen",
    askForApprovalButtonText: "Freigabe anfragen",
    showPasswordTooltip: "Passwort anzeigen",
    hidePasswordTooltip: "Passwort ausblenden",
    pleaseFixFields: "Bitte beheben Sie die folgenden Felder:",
    failedToCreateProcess: "Backup-Prozess konnte nicht erstellt werden",
    processAlreadyExists: "Ein Backup-Prozess existiert bereits",
  },
};

export const otaCreateBackupModalZhHans = {
  [pageNameKey]: {
    closeCreateBackupModalAriaLabel: "关闭创建备份弹窗",
    title: "创建备份",
    targetPathLabel: "备份路径（包含子文件夹和文件）",
    targetPathPlaceholder: "/appldisk",
    sourceMachineLabel: "源设备",
    usernameLabel: "用户名",
    usernamePlaceholder: "输入用户名",
    passwordLabel: "密码",
    passwordPlaceholder: "输入密码",
    privateKeyFileLabel: "使用私钥文件代替密码",
    helperText:
      "该请求会发送给操作员审批。只有在操作员在设备上确认后，备份才会开始。",
    cancelButtonText: "取消",
    askForApprovalButtonText: "请求批准",
    showPasswordTooltip: "显示密码",
    hidePasswordTooltip: "隐藏密码",
    pleaseFixFields: "请修复以下字段：",
    failedToCreateProcess: "创建备份流程失败",
    processAlreadyExists: "备份流程已存在",
  },
};

export const otaCreateBackupModalIt = {
  [pageNameKey]: {
    closeCreateBackupModalAriaLabel: "Chiudi la finestra crea backup",
    title: "Crea backup",
    targetPathLabel: "Percorso di backup (sottocartelle e file inclusi)",
    targetPathPlaceholder: "/appldisk",
    sourceMachineLabel: "Macchina sorgente",
    usernameLabel: "Nome utente",
    usernamePlaceholder: "Inserisci nome utente",
    passwordLabel: "Password",
    passwordPlaceholder: "Inserisci password",
    privateKeyFileLabel: "File chiave privata al posto della password",
    helperText:
      "Questa richiesta viene inviata all'operatore per l'approvazione. Il backup non inizierà finché non verrà confermato sulla macchina.",
    cancelButtonText: "Annulla",
    askForApprovalButtonText: "Richiedi approvazione",
    showPasswordTooltip: "Mostra password",
    hidePasswordTooltip: "Nascondi password",
    pleaseFixFields: "Si prega di correggere i seguenti campi:",
    failedToCreateProcess: "Impossibile creare il processo di backup",
    processAlreadyExists: "Esiste già un processo di backup",
  },
};

export const otaCreateBackupModalEs = {
  [pageNameKey]: {
    closeCreateBackupModalAriaLabel: "Cerrar modal de crear respaldo",
    title: "Crear respaldo",
    targetPathLabel: "Ruta para respaldo (subcarpetas y archivos incluidos)",
    targetPathPlaceholder: "/appldisk",
    sourceMachineLabel: "Máquina de origen",
    usernameLabel: "Nombre de usuario",
    usernamePlaceholder: "Introduce el nombre de usuario",
    passwordLabel: "Contraseña",
    passwordPlaceholder: "Introduce la contraseña",
    privateKeyFileLabel: "Archivo de clave privada en lugar de contraseña",
    helperText:
      "Esta solicitud se envía al operador para su aprobación. El respaldo no comenzará hasta que lo confirme en la máquina.",
    cancelButtonText: "Cancelar",
    askForApprovalButtonText: "Solicitar aprobación",
    showPasswordTooltip: "Mostrar contraseña",
    hidePasswordTooltip: "Ocultar contraseña",
    pleaseFixFields: "Por favor, corrija los siguientes campos:",
    failedToCreateProcess: "No se pudo crear el proceso de respaldo",
    processAlreadyExists: "Ya existe un proceso de respaldo",
  },
};

export const otaCreateBackupModalNl = {
  [pageNameKey]: {
    closeCreateBackupModalAriaLabel: "Sluit back-up aanmaken venster",
    title: "Back-up maken",
    targetPathLabel: "Pad voor back-up (submappen en bestanden inbegrepen)",
    targetPathPlaceholder: "/appldisk",
    sourceMachineLabel: "Bronmachine",
    usernameLabel: "Gebruikersnaam",
    usernamePlaceholder: "Voer gebruikersnaam in",
    passwordLabel: "Wachtwoord",
    passwordPlaceholder: "Voer wachtwoord in",
    privateKeyFileLabel: "Privatesleutelbestand in plaats van wachtwoord",
    helperText:
      "Dit verzoek gaat naar de operator voor goedkeuring. De back-up start pas nadat die op de machine is bevestigd.",
    cancelButtonText: "Annuleren",
    askForApprovalButtonText: "Goedkeuring vragen",
    showPasswordTooltip: "Wachtwoord tonen",
    hidePasswordTooltip: "Wachtwoord verbergen",
    pleaseFixFields: "Los de volgende velden op:",
    failedToCreateProcess: "Back-upproces kon niet worden aangemaakt",
    processAlreadyExists: "Er bestaat al een back-upproces",
  },
};

export const otaCreateBackupModalTr = {
  [pageNameKey]: {
    askForApprovalButtonText: "Onay isteyin",
    cancelButtonText: "İptal etmek",
    closeCreateBackupModalAriaLabel: "Yedekleme modunu kapat",
    helperText:
      "Bu talep onay için operatöre gider. Yedekleme, makinede onaylanana kadar başlamayacaktır.",
    failedToCreateProcess: "Yedekleme işlemi oluşturulamadı",
    processAlreadyExists: "Bir yedekleme işlemi zaten mevcut",
    hidePasswordTooltip: "Şifreyi gizle",
    passwordLabel: "Şifre",
    passwordPlaceholder: "Şifreyi girin",
    pleaseFixFields: "Lütfen aşağıdaki alanları düzeltin:",
    privateKeyFileLabel: "Şifre yerine Özel Anahtar dosyası",
    showPasswordTooltip: "Şifreyi göster",
    sourceMachineLabel: "Kaynak makinesi",
    targetPathLabel: "Yedeklenecek yol (alt klasörler ve dosyalar dahil)",
    targetPathPlaceholder: "/appldisk",
    title: "Yedekleme Oluştur",
    usernameLabel: "Kullanıcı adı",
    usernamePlaceholder: "Kullanıcı adını girin",
  },
};
